import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";
import { findDocument } from "./findDocument";
import { findSigners } from "./findSigners";

export const signDocument = createAsyncThunk(
  "documentSignerShow/signDocument",
  async (params, { getState, dispatch, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const documentId = state.documentSignerShow.document.id;

      const url = new URL(`${api.baseURL}document/sign`);
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(url.toJSON(), {
        method: "POST",
        body: JSON.stringify({
          document: documentId,
          user: state.userAuthentication.user?.id,
        }),
        headers: headers
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data = await response.json();

      dispatch(findDocument(documentId));
      dispatch(findSigners(documentId));

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
